// @flow

import React from 'react';
import type { FieldProps } from '../../../types';
import Checkbox from './checkbox';

type Props = {|
  ...FieldProps,
  label: string,
|};

export default ({
  input,
  meta: {
    error,
    touched,
  },
}: Props) => (
  <Checkbox
    error={Boolean(error && touched)}
    className=""
    checked={false}
    {...input}
  />
);
